// extracted by mini-css-extract-plugin
export default {"list":"perfiles-modulo-list_list__iTQmB"};